//import React from "react"
//const My = ({ pageContext }) => {
//  return <div>Ciao</div>
//}
//export default Page

import React from "react"
// import { Link } from "gatsby"
//import Layout from "../../components/layout"
// import SEO from "../components/seo"
import {default as SeoComponent} from "../components/seo"
import SavedPost from "../components/saved-post"
// import PostHeaderMeta from "../components/post-header-meta"
// import PostFooterMeta from "../components/post-footer-meta"
//import AniLink from "gatsby-plugin-transition-link/AniLink"
import { toast } from 'react-toastify';
// import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import { navigate } from "gatsby";
import { window, document } from 'browser-monads';
// import SharePanel from "../components/share"
import { useState } from 'react'
// import { useEffect } from 'react'
import { useLayoutEffect } from 'react'
// import he from "he";


const { localStorage } = window;

var time_to_close=10000;
// var myTimer;
// var alertArticleDisplayed = false;
// var navigate_to_next_article = true;
// var toastId;
var position;
// var alertArticleDisplayed = false;
// var start = false;
// var middle = false;
// var end = false;

if (window.innerWidth>=500) {
  position = toast.POSITION.TOP_RIGHT;
} else {
  position = toast.POSITION.BOTTOM_CENTER;
}

toast.configure({
  autoClose: time_to_close,
  position: position,
  //draggable: false,
  //etc you get the idea
});

function mag_remove_preferred(url) {
  localStorage.removeItem(url?url+'_prefered':window.location.pathname+'_prefered');
  localStorage.removeItem(url?url+'_prefered_info':window.location.pathname+'_prefered_info');

  // var toastId =
  toast('Rimosso dagli articoli salvati',{
    hideProgressBar: true,
    autoClose: 2000,
    closeOnClick: true }
    );
}

const My = props => {
  const {
    pageContext: {
      id,
      postId,
      // title,
      // excerpt,
      // content,
      // uri,
      // featuredImage,
      // link,
      // date,
      // author,
      // categories,
      // tags,
      // prev,
      // next,
      // terms,
      vertical,
    },
  } = props

  var myInterval;

  const Msg = ({ closeToast, link, obj, title }) => (
    <div>
      <p><strong>Sei sicuro di voler rimuovere</strong></p>
      <p><strong>{title}</strong> ?</p>
      <button onClick={()=>removePrefered(obj)}>Si</button>
      <button onClick={()=>closeToast()}>No</button>
    </div>
  )

  var items = {...localStorage};

  function removePrefered(obj) {
    if (window.ga) {
      window.ga('send', {
        hitType: 'event',
        eventCategory: 'My',
        eventAction: 'preferred',
        eventLabel: 'remove'
      });
    }

    mag_remove_preferred(obj.replace("_prefered",""));
    localStorage.setItem("unread", parseInt(localStorage.getItem("unread") !== null ? localStorage.getItem("unread") : 0) - 1);
    if (localStorage.getItem("unread") != null &&  parseInt(localStorage.getItem("unread"))>0) {
      //set unread on the menu
      //alert("display unread");
      document.getElementById("unread_menu").style.display = "block";
      document.getElementById("unread_menu").innerHTML = parseInt(localStorage.getItem("unread"));
    } else {
      document.getElementById("unread_menu").style.display = "none";
    }

    var animDiv = document.getElementById("div_"+obj);
    var opacity = 1;
    myInterval = setInterval(function() {
      opacity = opacity - 0.05;
      animDiv.style.opacity= opacity;

      if (opacity <=0) {
        clearInterval(myInterval);
        if (document.getElementById("div_"+obj)) {
          document.getElementById("div_"+obj).style.display="none";
          updateEmptyLayout();
        }
      }
    },25);
  }

  function updateEmptyLayout() {
    var show_empty = true;

    Object.keys(items).forEach((obj, k) => {
      if (obj.indexOf("_prefered") !== -1 && obj.indexOf("_prefered_info") === -1) {
        // var prefInfo;
        //window.alert(obj+"_info");
        if (localStorage.getItem(obj+"_info") !== null) {
          show_empty = false;
        }
      }
    });
    setShowEmpty(show_empty);
  }

  function showConfirmation(obj, title) {
    // toastId =
    toast(<Msg obj={obj} title={title}/>, {
      position: position,
      hideProgressBar: true,
      className: 'center-toast',
      onOpen: ({ foo }) => console.log('toast onOpen'),
      onClose: ({ foo }) => function () {}
      });
  }

  const [empty_visibility, setShowEmpty] = useState(false)

  useLayoutEffect(()=>{
    window.scrollTo(0,1);
    localStorage.setItem("unread", 0);
    updateEmptyLayout();

    //setShowEmpty(true);
    //setShowEmpty(true);
    return () => {
    };
  });

  function handleBookmark(postUri, postTitle) {
    showConfirmation(postUri, postTitle);
  }

  return (
    <div className="newmag-single-article" vertical={vertical}>
      <SeoComponent title={"Articoli Salvati"} description={""} />
      <div className="newmag_salvati" style={{background: "linear-gradient(53.35deg, #EE3D49 0%, #CB356B 100%)", marginLeft: "-4.7%", height: "310px", width: "110%"}}>
        <div className="newmag_salvati_title" style={{color: "white", height: "135px",width: "557px", fontFamily: "aktiv-grotesk",fontSize: "108px",letterSpacing: "2.4px",lineHeight: "139px", fontWeight:"800", paddingLeft:"145px", paddingTop:"59px"}}>Articoli Salvati</div>
      </div>
      <article
        data-id={id}
        id={`post-${postId}`}
        className={`newmag_my_article newmag-article post-${postId} post type-post status-publish format-standard hentry category-react tag-accessibility tag-gatsby `}
      >

        <div className="newmag_my_list" id="article_list">
        {Object.keys(items).map((obj, k) => {

        if (obj.indexOf("_prefered") !== -1 && obj.indexOf("_prefered_info") === -1) {
            var prefInfo;
            // let content_ok = false;
            //window.alert(obj+"_info");
            if (localStorage.getItem(obj+"_info") !== null)
              prefInfo = JSON.parse(localStorage.getItem(obj+"_info"));
            else return "";
            console.log('prefInfo', prefInfo);
            // content_ok = true;
            // var author = '';
            // if (prefInfo.author) {
            //   if (typeof prefInfo.author === typeof "") {
            //     author = prefInfo.author;
            //   } else if (prefInfo.author.name) {
            //     author = prefInfo.author.name;
            //   } else if (prefInfo.author.node && prefInfo.author.node.name) {
            //     author = prefInfo.author.node.name;
            //   }
            // }

            return <SavedPost postUri={prefInfo.url} onClickBookmark={handleBookmark}></SavedPost>

            // return <section key={obj} id={"div_"+obj}  style={{zIndex: "98", marginBottom: "32px", marginTop: "32px"}}>
            //         <div className="head-posts-container">
            //           <div className="head-save-element" >
            //             <Link className="a_black"  to={prefInfo.url} >
            //             <div className="left_save_posts">
            //                 <div style={{backgroundImage: "url("+prefInfo.img+")"}} className="map_save_posts_imgdiv" ></div>
            //                 { prefInfo.is_media && !prefInfo.video && (<div style={{background: "linear-gradient(180deg, rgba(255,255,255,0), rgba(255,255,255,0.7))"}} className="map_save_posts_imgdiv"></div> )}
            //                 { prefInfo.is_media && !prefInfo.video && (<div style={{backgroundImage: "url(/img/sound_anim1.gif)"}} className="map_save_posts_imgdiv_video" ></div>)}
            //                 { prefInfo.is_media && prefInfo.video && (<div dangerouslySetInnerHTML={{ __html: prefInfo.video }} />  )}
            //             </div>
            //             </Link>
            //             <div className="right_save_posts">
            //               <div className="group">
            //                 <a className="a_black" title="Vai alla categoria" href="/">
            //                 <div className="floatleft mag_big_post_single_category" ></div>
            //                 </a>
            //                 <div className="floatright">
            //                   <button style={{background: 'transparent', padding:"5px" }} onClick={()=>showConfirmation(obj, prefInfo.title)}>
            //                     <img
            //                       alt="Prefered"
            //                       src={"/img/bookmark_icon_full@2x.png"}
            //                       style={{
            //                         marginTop: "7px",
            //                         width: "26px",
            //                         height: "auto"
            //                       }}
            //                     />
            //                   </button>
            //                 </div>
            //               </div>
            //               <Link className="a_black" title={prefInfo.title} to={prefInfo.url}>
            //                 <div className="group " >
            //                   <h2
            //                     style={{
            //                       fontFamily: "aktiv-grotesk",
            //                       fontSize: '30px',
            //                       letterSpacing: '-0.43px',
            //                       lineHeight: '37px',
            //                     }}
            //                     >{prefInfo.title}</h2>
            //                 </div>
            //                 <div className="group">
            //                   <div className="floatleft onlydesktop"><p className="mag_post_author">{author}</p></div>
            //                   <div className="floatright_save_posts__onlymobile">
            //                     <p style={{
            //                       height: '24px',
            //                       width: '225px',
            //                       color: '#B2B4CA',
            //                       fontFamily: "urw-din",
            //                       fontSize: '12px',
            //                       letterSpacing: '0',
            //                       lineHeight: '24px',
            //                       textTransform: 'uppercase'
            //                     }}>{author}</p>
            //                   </div>
            //                 </div>
            //               </Link>
            //             </div>
            //           </div>
            //         </div>
            //       </section>
            //return <div id={"div_"+obj} style={{display: "flex"}}><a href={obj.replace("_prefered","")}><div style={{width:"100px", height:"100px", backgroundSize: "cover", backgroundImage: "url("+prefInfo.img+")"}}></div><div>- {prefInfo.title}</div></a><button onClick={()=>showConfirmation(obj)}>X</button></div>
        } else {
          return "";
        }


        })
        }
          <div
            className="no-saved-articles"
            style={{
              display: empty_visibility?"block":"none",
              textAlign: 'center',
              background: 'white',
              // marginLeft: '1rem',
              // marginRight: '1rem',
              // borderRadius: '13px',
              // backgroundColor: '#FFFFFF',
              // boxShadow: '0 6px 24px 0 rgba(0,0,0,0.5)',
              }}>
            <div style={{
              backgroundPosition: 'center',
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              backgroundImage: 'url("/img/bookmark@2x.png")',
              marginLeft: 'auto',
              marginRight: 'auto',
              marginBottom: '1rem',
              marginTop: '3rem',
              width: '3rem',
              height: '3rem'
            }}>
            </div>
            Non hai ancora salvato nessun articolo. <br />
            Tocca l’icona del segnalibro per
            aggiungerli ai tuoi preferiti.
          </div>
        </div>

      </article>
    </div>
  )
}

export default My
